<template>
    <div class="conf-wrp">
        <div class="content-wrp">
            <div class="content">
                <el-form class="form" :model="value" :rules="rules" ref="form" label-width="20%">
                    <section>
                        <div class="title">
                            <span>基础设置</span>
                        </div>
                        <div class="conf">
                            <!-- <el-form-item label="标题设置:" prop="titleSet">
                                <el-checkbox v-model="value.titleSet">商品标题过长自动截取（只取前30个字）</el-checkbox>
                            </el-form-item>
                            <el-form-item label="" prop="imgNumSet">
                                <el-checkbox v-model="value.imgNumSet">商品总图片超过平台限制自动截断详情图（最多50张）</el-checkbox>
                            </el-form-item> -->
                             <el-form-item label="库存预减类型" prop="reduceType">
                                 <el-radio-group v-model="value.reduceType">
                                    <el-radio :label="1">下单减库存</el-radio>
                                    <el-radio :label="2">付款减库存</el-radio>
                                </el-radio-group>
                            </el-form-item>
                            <el-form-item label="客服电话" prop="telephoneConf">
                                <el-radio-group class="telephoneConf" v-model="value.telephoneConf">
                                    <el-radio class="confItem" :label="1">下载抖音后台客服电话 <span style="color: red">（注意：不建议，下载后客服电话加密，不支持解密，铺货时需要手动调整）</span> </el-radio>
                                    <el-radio class="confItem" :label="2">下载商品后，客服电话置空</el-radio>
                                    <el-radio class="confItem" :label="3">
                                        配置默认客服电话
                                        <el-input
                                            v-model="value.telephone"
                                            :disabled="value.telephoneConf !== 3"
                                            placeholder="请输入客服电话"
                                            maxlength="32"
                                            style="width: 300px; margin-left: 10px"
                                        ></el-input>
                                    </el-radio>
                                </el-radio-group>
                            </el-form-item>
                            <el-form-item label="规格拆分规则" prop="specSplitConfig">
                                <div class="spec-split-content">
                                    <div class="spec-switch-wrp">
                                        <el-switch v-model="specSplitConfig.flag"></el-switch>
                                    </div>
                                    <div class="spec-split-desc tips" v-if="specSplitConfig.flag">
                                        开启配置后，根据基础资料规格时规格值时，将匹配关键字对规格值进行拆分，拆分后生成新的规格值。关键字及关键字包含的内容，将作为规格备注。若拆分后新规格值为空，则拆分规则不生效；
                                    </div>
                                    <div v-if="specSplitConfig.flag">
                                        <div class="spec-split-keyword-type">
                                            <span class="label">关键字:</span>
                                            <el-radio-group v-model="specSplitConfig.keywordType" @change="handleKeywordTypeChange">
                                                <el-radio :label="1">（）</el-radio>
                                                <el-radio :label="2">【】</el-radio>
                                                <el-radio :label="3">空格</el-radio>
                                                <el-radio :label="4">自定义</el-radio>
                                            </el-radio-group>
                                        </div>
                                        <div v-if="specSplitConfig.keywordType === 4" class="spec-split-custom">
                                            <div class="custom-row">
                                                开始关键字：
                                                <el-input
                                                    v-model="specSplitConfig.startKeyword"
                                                    placeholder="支持输入10个字符"
                                                    maxlength="10"
                                                    style="width: 200px; margin-right: 40px"
                                                    @input="validateSpecKeyword"
                                                ></el-input>
                                               结束关键字：
                                                <el-input
                                                    v-model="specSplitConfig.endKeyword"
                                                    placeholder="支持输入10个字符"
                                                    maxlength="10"
                                                    style="width: 200px;"
                                                    @input="validateSpecKeyword"
                                                ></el-input>
                                            </div>
                                            <div class="custom-desc tips">
                                                开始关键字和结束关键字，支持独立输入，即仅维护一组关键字后，开始关键字之后的所有内容或结束关键字之前的所有内容，均归属规格备注
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </el-form-item>
                            <el-form-item label="尺码表智能填充" prop="sizeAi">
                                <div class="switch-wrp">
                                    <el-switch v-model="value.sizeAi" :active-value="1" :inactive-value="0"></el-switch>
                                </div>
                                <div class="tips">
                                    开启配置，铺货时若店铺尺码表或商品尺码表不符合平台发布规则要求，系统将智能填充商品尺码表信息进行铺货，智能填充尺码信息仅供参考，铺货后可前往后台查看尺码信息。
                                </div>
                            </el-form-item>
                            <el-form-item label="尺码信息：" prop="sizeType">
                                <el-radio-group v-model="value.sizeType">
                                    <el-radio :label="3">店铺尺码表</el-radio>
                                    <el-radio :label="1">商品尺码表</el-radio>
                                    <!-- <el-radio :label="2">商品尺码图</el-radio> -->
                                </el-radio-group>
                            </el-form-item>
                            <template v-if="value.sizeType == 2">
                                <el-form-item >
                                    <span style="font-size: 12px;">
                                        选择此项，使用商品资料的尺码图，如果商品未传尺码图、尺码图不符合平台要求（如服饰缺少身高、重），会有上架失败风险<br />
                                    </span>
                                </el-form-item>
                            </template>
                            <template v-else-if="value.sizeType == 3">
                                <el-form-item>
                                    <!-- 店铺尺码表组件内容 
                                        变量：shopList；店铺列表，默认初始值，店铺对应尺码模版列表 
                                        数据设置默认值：shopSizeListData:[{shopId,templateName,templateId}] 
                                        Icon: 不同平台Icon
                                        预览方法回调
                                    -->
                                    <ShopSizeListVue
                                        ref="shopSizeRef"
                                        :shopList="shopList"
                                        v-model="value.sizeTemplateList"
                                        :icon='ddianImg'
                                        @reviewShopSize="reviewShopSize"
                                        @editShopSize="editShopSize"
                                    />
                                </el-form-item>
                            </template>
                            <template v-else>
                                <el-form-item style="font-size: 12px;" v-if="value.sizeType == 1">
                                    <span style="font-size: 12px;">
                                    选择此项，使用商品资料的尺码表信息
                                    </span>
                                </el-form-item>
                            </template>
                            <el-form-item label="店铺品牌设置：">
                                <BrandSettingConfig
                                    v-if="shopList.length"
                                    ref="branchSettingConfig"
                                    v-model="brandConfList"
                                    :shopList="shopList"
                                />
                                <span class="no-shops" v-else>暂无平台店铺</span>
                            </el-form-item>
                            <el-form-item label="类目外品牌设置：">
                                <BrandSettingOtherConfig
                                    v-if="shopList.length"
                                    ref="branchSettingConfig"
                                    v-model="dataSourceCategory"
                                    :shopList="shopList"
                                />
                                <span class="no-shops" v-else>暂无平台店铺</span>
                            </el-form-item>
                        </div>
                    </section>
                    <section>
                        <div class="title">
                            <span>款式编码来源字段</span>
                        </div>
                        <div class="conf">
                            <el-form-item label="款式编码来源字段：" prop="outerType">
                                 <el-radio-group v-model="value.outerType">
                                    <el-radio :label="1">商品ID</el-radio>
                                    <el-radio :label="2">货号或款号</el-radio>
                                </el-radio-group>
                            </el-form-item>
                            <el-form-item>
                                <span style="font-size: 12px">从抖店下载商品资料到基础资料时可以选择货号或款号作为平台资料商品的款式编码来源</span>
                            </el-form-item>
                        </div>
                    </section>
                    <section>
                        <div class="title">
                            <span>库存设置</span>
                        </div>
                        <div class="conf">
                            <el-form-item label="铺货时，进行库存默认设置:" >
                                <el-switch v-model="checkInstock"></el-switch>
                            </el-form-item>
                            <el-form-item v-if="checkInstock" label="库存默认值" prop="instock">
                                <div class="instock">
                                    <span class="prev">铺货到抖音的SKU库存默认值&nbsp;=&nbsp;</span>
                                    <el-input v-model="value.instock" style="width: 120px" placeholder="请输入库存数"></el-input>
                                    <span class="tips">&nbsp;(此值应用于商品铺货时，对商品各SKU的库存初始化值，最大值为99999)</span>
                                </div>
                            </el-form-item>
                        </div>
                    </section>
                    <section>
                        <div class="title">
                            <span>图片设置</span>
                        </div>
                        <div class="conf">
                            <div style="padding-left:15%;">图片修正规则：按照平台比例和尺寸大小要求，修正成最优且符合要求的图片。若图片大小不符合平台要求，将自动压缩后重新上传，不支持压缩20M以上的图片。</div>
                            <el-form-item prop="autoCropImageConfigList">
                                <el-checkbox-group v-model="value.autoCropImageConfigList">
                                    <el-checkbox label="mainImg">主图</el-checkbox>
                                    <el-checkbox label="mainImg34">3:4主图</el-checkbox>
                                    <el-checkbox label="guideImg">3:4导购图</el-checkbox>
                                    <el-checkbox label="whiteImg">白底图</el-checkbox>
                                    <el-checkbox label="desc">商品详情图</el-checkbox>
                                    <el-checkbox label="skuImg">规格图</el-checkbox>
                                    <el-checkbox label="skuPicture">sku图</el-checkbox>
                                </el-checkbox-group>
                            </el-form-item>
                        </div>
                    </section>
                    <section>
                        <div class="title">
                            <span>运费模板设置</span>
                        </div>
                        <div class="conf">
                            <el-form-item label="运费设置:" prop="shipSet" label-width="120px">
                                <div class="ship-wrp" v-if="shopList.length > 0">
                                    <div class="item" v-for="(item, idx) in shopList" :key="idx">
                                        <div class="shopname">
                                            <img class="shop-img" :src="item.icon"/>
                                            <el-tooltip v-if="item.channelIcon" :content="item.channelName" style="margin: 0px -6px 0px 6px;">
                                                <el-image :src="item.channelIcon" style="width: 18px; height: 18px;overflow: unset;top: 4px;"></el-image>
                                            </el-tooltip>
                                            <span>{{item.shortTitle || item.title}}</span>
                                        </div>
                                        <el-select 
                                            v-model="shipsValue[item.id]" 
                                            placeholder="请选择运费模板" 
                                            clearable
                                            filterable
                                            :remote="item.source ==='fxg'"
                                            :remote-method="query => queryTemplates(query, item)"
                                            :loading="selectLoading" 
                                            @visible-change="isVisible => changeSelect(isVisible, item)"
                                            width="150px">
                                            <el-option
                                                v-for="ship in shipsTemplate[item.id]"
                                                :key="ship.id"
                                                :label="ship.name"
                                                style="width: 150px;"
                                                :title="ship.name"
                                                :value="ship.id">
                                            </el-option>
                                        </el-select>
                                        <!-- <div><el-link class="no-border" @click="refreshTemplate(item.id, item.userId)">刷新模板</el-link></div> -->
                                    </div>
                                </div>
                                <span v-else class="no-shops">暂无平台店铺</span>
                            </el-form-item>
                        </div>
                    </section>
                    <section>
                        <div class="title">
                            <span>上架设置</span>
                        </div>
                        <div class="conf">
                            <el-form-item label="上架设置:" prop="shelfType">
                                <el-radio-group v-model="value.shelfType">
                                    <el-radio :label="1">立即上架</el-radio>
                                    <el-radio :label="2">放入草稿箱</el-radio>
                                    <el-radio :label="0">下架</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>
                    </section>
                    <PriceConf ref="PriceConfRef" platform="fxg" :priceList="value.price" :shopPriceConf="value.shopPriceConf"></PriceConf>
                    <div class="btns"  style="margin: 0px;">
                        <el-button type="primary" @click="save">保存模板</el-button>
                        <el-button @click="back">返回</el-button>
                    </div>
                </el-form>
            </div>
        </div>
        <CascaderDialog platform="fxg" ref="CascaderDialog" />
        <!-- 添加尺码信息弹窗 -->
        <AddSize ref="addSizeDialog" :sizeType="value.sizeType"  :shopList="shopList" @sizeTemplate='addOrUpdateSizeTemplate' :templateList='value.sizeTemplateList' :componentTemplateRule="componentTemplateRule"/>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';
import CascaderDialog from '../center/components/PlatformCategoryInput/CascaderDialog.vue'
import '@/assets/css/prod.scss';
import {getDistributionConfig, updateDistributionConfig, getFxgTemplateList, getFxgGxTemplateList} from '@servers/prod/conf/index.js'
import PriceConf from './components/PriceConf.vue';
import BrandSettingConfig from './components/BrandSettingConfig/index.vue';
import BrandSettingOtherConfig from './components/BrandSettingOtherConfig/index.vue';
import ShopSizeListVue from '@components/prod/center/components/DdianInfoForm/shopSizeList.vue';
import ddianImg from "@/assets/images/ddian.png";
import AddSize from '@components/prod/center/components/DdianInfoForm/addSizeDialog.vue'
import { cloneDeep } from 'lodash';


const PLATFORMID = 'TouTiaoFXG';

export default {
    props: {
        back: Function
    },
    provide(){
        return {
            platform:'fxg',
        }
    },
    components: {
        CascaderDialog,
        PriceConf,
        BrandSettingConfig,
        ShopSizeListVue,
        AddSize,
        BrandSettingOtherConfig
    },
    data() {
        const validateInstock = (rule, value, callback) => {
            const reg = /^[0-9]+$/;
            if (value === '' || value === null) {
                callback(new Error('请输入库存数'));
            } else if (!reg.test(value)) {
                callback(new Error('库存数必须为正整数'));
            } else if (value <= 0 || value >= 99999) {
                callback(new Error('库存数必须为0-99999之间的整数'));
            } else {
                callback();
            }
        }
        return {
            dialogType:'add',
            checkInstock: false,
            shopList: [],
            value: {
                titleSet: false,
                imgNumSet: false,
                instock: null,
                reduceType: 1,
                sizeAi: 0,
                telephoneConf: 1,
                telephone: '',
                shelfType: 2,
                outerType: 2,
                autoCropImageConfigList:[],
                sizeTemplateList:[],
                sizeType:3,
            },
            componentTemplateRule: {
                mustInput: false,
                sizeDimensionRange: {},
            }, // 尺码校验
            ddianImg:ddianImg,
            selectBrandLoading: false,
            selectLoading: false,
            rules: {
                instock: [
                    {required: true, message: '请输入库存数'},
                    {validator: validateInstock}
                ],
                shelfType: [
                    {required: true, message: ''},
                ]
            },
            shipsValue: {// 运费模板
            },
            shipsTemplate: { // 运费模板列表

            },
            categoryBrandRelationsList:[],
            brandConfList: [],
            specSplitConfig: {
                flag: false,
                keywordType: 1,
                startKeyword: '',
                endKeyword: ''
            },
        }
    },
    watch:{
        shops_all:{
            handler(val) {
                if (val.length) {
                    this.getConf();
                }
            }
        }
    },
    computed:{
        ...mapGetters(['shops_all']),
        dataSourceCategory: {
            get(){
                if (!this.categoryBrandRelationsList?.length) {
                    return [];
                }
                return this.categoryBrandRelationsList.flatMap(item => 
                    item.relations.map(childRelation => ({
                        ...childRelation,
                        previewCategoryId: childRelation.categoryId,
                        parent: { shopId: item.shopId },
                        status: item.status
                    }))
                );
            },
            set(next){
                const grouped = {};
                (next || []).forEach(row => {
                    const shopId = row?.parent?.shopId;
                    if(!shopId) return;
                    if(!grouped[shopId]) grouped[shopId] = [];
                    const copy = { ...row };
                    delete copy.parent;
                    delete copy.previewCategoryId;
                    grouped[shopId].push(copy);
                });
                this.categoryBrandRelationsList = Object.keys(grouped).map(shopId => {
                    const shop = this.shopList.find(shop => shop.id == shopId) || {}
                    return {
                        shopId: isNaN(Number(shopId)) ? shopId : Number(shopId),
                        shopType: shop.source === 'fxg_gx' ? 'fxg_gx' : PLATFORMID,
                        relations: grouped[shopId]
                    }
                });
            }
        }
    },
    mounted() {
        this.getConf();
    },
    methods: {
        addOrUpdateSizeTemplate(sizeTemplate) {
            // 确保 sizeTemplateList 数组存在
            if (!this.value.sizeTemplateList) {
                this.$set(this.value, 'sizeTemplateList', []);
            }
            
            // 根据 shopId 查找对应的店铺数据索引
            const shopId = sizeTemplate.shopId;
            const existingIndex = this.value.sizeTemplateList.findIndex(item => item.shopId === shopId);
            
            if (existingIndex !== -1) {
                // 如果找到对应的店铺数据，进行替换
                this.$set(this.value.sizeTemplateList, existingIndex, sizeTemplate);
                this.$refs.shopSizeRef.initValuesMap();
            } else {
                // 如果没有找到对应的店铺数据，添加新的数据
                // 使用 Vue.set 或者重新赋值整个数组来确保响应式更新
                const newArray = [...this.value.sizeTemplateList, sizeTemplate];
                this.$set(this.value, 'sizeTemplateList', newArray);
            }
            
            // 强制触发视图更新
            this.$forceUpdate();
        },
        onSizePicUrlChange(url) {
            this.value.sizePicUrl = url
        },
        reviewShopSize(payload){
            this.previewTemplateInfo = payload
            if(!(payload.templateInfo && payload.templateInfo.templateId)){
                this.$message.error('数据模版未选择，不能预览')
                return
            }
            this.dialogType = 'preview'
            this.showAddSize({previewTemplateInfo:payload})
        },
        editShopSize(payload) {
            this.previewTemplateInfo = payload
            if(!(payload.templateInfo && payload.templateInfo.templateId)){
                this.$message.error('数据模版未选择，不能编辑')
                return
            }
            this.dialogType = 'edit'
            this.showAddSize({previewTemplateInfo:payload,dialogType: 'edit'})
        },
        showAddSize({previewTemplateInfo,dialogType}) {
            if(true) {
                this.$refs.addSizeDialog.clearShopId();
            }
            this.$refs.addSizeDialog.method_open({previewTemplateInfo:previewTemplateInfo ||{},dialogType})
        },
        delSize() {
            this.value.sizeTemplateList = [];
            this.$refs.addSizeDialog?.clearTemplateConfig();
            this.$refs.addSizeDialog?.clearShopId();
        },
        async getConf() {
            const res = await getDistributionConfig({shopType: PLATFORMID}) || {};
            const shopList = this.$store.getters.get_AllShops_BySource('fxg');
            const fxg_gxShopList = this.$store.getters.get_AllShops_BySource('fxg_gx');
            this.shopList = [...shopList, ...fxg_gxShopList];

            this.checkInstock = res.isCommodityStock === 1;
            this.value.titleSet = res.isCommodityTitle === 1;
            this.value.imgNumSet = res.isCommodityImage === 1;
            this.value.instock = res.stockNumber;
            this.value.shelfType = res.shelfState || res.shelfState === 0 ? res.shelfState : this.value.shelfType;
            this.value.reduceType = res.reduceType;
            this.value.sizeAi = res.sizeAi || 0;
            this.value.telephoneConf = res.telephoneConf;
            this.value.telephone = res.telephone;
            this.value.outerType = res.outerType || 2;
            this.value.price = this.safeJsonParse(res.price, []);
            this.value.autoCropImageConfigList = res.autoCropImageConfigList || [];
            this.value.sizeType = res.sizeType || 3;
            this.value.shopPriceConf = this.safeJsonParse(res.shopPriceConf, []);
            this.value.sizeTemplateList = (res.sizeTemplateList || []).map(item => ({
                ...item,
                templateId: item.templateIdStr
            }));
            this.parseSpecSplitConfig(res.specSplitConfig);

            this.intiTemplate(res.templateList);
            this.categoryBrandRelationsList = res.categoryBrandRelations || [];
            this.handleUniqData(res.brandConfList || []);
        },
        safeJsonParse(str, fallback) {
            if (!str) return fallback;
            try { return JSON.parse(str); } catch { return fallback; }
        },
        parseSpecSplitConfig(raw) {
            const defaults = { flag: false, keywordType: 1, startKeyword: '', endKeyword: '' };
            if (!raw) return;
            try {
                const parsed = JSON.parse(raw);
                Object.assign(this.specSplitConfig, defaults, parsed);
            } catch (e) {
                console.error('specSplitConfig parse error', e);
            }
        },
        handleUniqData(value){
            const list = cloneDeep(value)
            const data = list.map((item,index)=>{
                // item.id = uniqueId(index+'_')
                item.id = index+'_'+item.shopIds.join('')
                return item
            })
            this.brandConfList = data
        },
        queryTemplates(queryName, shop) {
            this.getTemplateList(shop, queryName)
        },
        async getTemplateList(shop, name) {
            this.selectLoading = true;
            const userId = shop.userId;
            const shopId = shop.id;
            let list = []
            if(shop.source === 'fxg_gx') {
                list = await getFxgGxTemplateList({userId});
            } else {
                list = await getFxgTemplateList({userId, name, page: 0, size: 30});
                list = list.map(ship => {
                    const temp = ship.template || {};
                    return {
                        name: temp.templateName,
                        id: temp.id
                    }
                })
            }
            
            this.selectLoading = false;
            this.shipsTemplate[shopId] = list;
            const findItem = list.find(item => item.id === this.shipsValue[shopId]);
            if(!findItem) {
                this.shipsValue[shopId] = ''
            }
        },
        intiTemplate(templateList=[]) {
            const ships = {};
            const shopUserIdMap = {};
            const shopList = this.shopList
            for(let shop of shopList) {
                ships[shop.id] = '';
                shopUserIdMap[shop.userId] = shop.id;
                this.shipsTemplate[shop.id] = [];
            }
            const shipsTemp = {};
            if (shopList.length && templateList) {
                    templateList.forEach(item => {
                        // item.shopId = shopUserIdMap[item.shopId] || item.shopId;
                        ships[item.shopId] = item.templateId;
                        if (this.shipsTemplate[item.shopId] && !this.shipsTemplate[item.shopId].length) {
                            shipsTemp[item.shopId] = [{name: item.templateName, id: item.templateId}]
                        }
                    })
            }
            this.shipsTemplate = shipsTemp;
            this.shipsValue = ships;
        },
        changeSelect(isVisible, shop) {
            // 如果下拉框关闭，直接返回
            if (!isVisible || !shop?.id) return;
            const shopId = shop.id;
            const templates = this.shipsTemplate[shopId];
            
            // 当模板列表为空，或者只有一个模板且当前选中值就是该模板时，重新获取模板列表
            const shouldRefresh = !templates?.length || (templates.length === 1 && templates[0].id === this.shipsValue[shopId]);
            
            if (shouldRefresh) {
                this.getTemplateList(shop, '');
            }
        },
        findTemplateName(shopid, tempId) {
            if (!this.shipsTemplate[shopid]) return '';
            for(let item of this.shipsTemplate[shopid]) {
                if (item.id === tempId) {
                    return item.name;
                }
            }
        },
        handleKeywordTypeChange(type) {
            // 切换到预设关键字时清空自定义输入
            if (type !== 4) {
                this.specSplitConfig.startKeyword = '';
                this.specSplitConfig.endKeyword = '';
            }
        },
        validateSpecKeyword(value) {
            // 中文字符算2个字符，英文及特殊符号算1个字符，最多10个字符
            let charCount = 0;
            for (let i = 0; i < value.length; i++) {
                const code = value.charCodeAt(i);
                if (code > 127) {
                    charCount += 2; // 中文
                } else {
                    charCount += 1; // 英文及特殊符号
                }
            }
            if (charCount > 10) {
                this.$message.warning('最多支持输入10个字符（中文为2个字符，英文及特殊符号为1个字符）');
            }
        },
        save() {
            this.$refs.form.validate(async valid => {
                if (valid) {
                    const {
                        titleSet,
                        imgNumSet,
                        instock,
                        shelfType,
                        reduceType, 
                        sizeAi,
                        telephoneConf,
                        telephone,
                        outerType,
                        autoCropImageConfigList,
                        sizeType,
                        sizeTemplateList
                    } = this.value;
                    const templateList = []
                    Object.keys(this.shipsValue).forEach(id => {
                        const name = this.findTemplateName(id, this.shipsValue[id]);
                        const channel = this.shopList.find(shop => shop.id == id)?.channel
                        // if (this.shipsValue[id] && name) {

                            templateList.push({
                                shopId: id,
                                templateId: this.shipsValue[id],
                                templateName: name,
                                channel
                            });
                        // }
                    });
                    // const categoryBrandRelations = this.getBrandConfParamsNew()
                    let [commConf, shopConf] = this.$refs.PriceConfRef.getData();
                    const params = {
                        shopType: PLATFORMID,
                        isCommodityTitle: titleSet ? 1 : 0,
                        isCommodityImage: imgNumSet ? 1 : 0,
                        isCommodityStock: this.checkInstock ? 1 : 0,
                        stockNumber: this.checkInstock ? `${instock === null ? '' : instock}` : '',
                        shelfState: shelfType,
                        reduceType: reduceType,
                        sizeAi,
                        telephoneConf,
                        telephone,
                        templateList: templateList,
                        categoryBrandRelations: this.categoryBrandRelationsList,
                        brandConfList: this.brandConfList,
                        outerType: outerType,
                        price: JSON.stringify(commConf),
                        autoCropImageConfigList,
                        sizeType,
                        sizeTemplateList,
                        shopPriceConf:JSON.stringify(shopConf),
                        specSplitConfig: JSON.stringify(this.specSplitConfig),

                    }
                    updateDistributionConfig(params).then(res => {
                        this.getConf();
                        res && this.$message.success('保存成功');
                    }).catch(err => {
                    })
                }
            })
        },
    }
}
</script>

<style lang="scss"  scoped>
.conf-wrp{
    overflow-y: unset !important;
}
.telephoneConf{
    display: flex;
    flex-direction: column;
    .confItem{
        margin: 6px 0px;
    }
}
.spec-split-content {
    .spec-switch-wrp {
        display: flex;
        align-items: center;
        .switch-label {
            margin-right: 10px;
            font-size: 14px;
        }
    }
    .spec-split-desc {
        font-size: 12px;
        color: #909399;
    }
    .spec-split-keyword-type {
        display: flex;
        align-items: center;
        margin-top: 12px;
        .label {
            margin-right: 10px;
            white-space: nowrap;
        }
    }
    .spec-split-custom {
        margin-top: 12px;
        .custom-row {
            display: flex;
            align-items: center;
            .label {
                font-size: 14px;
                margin-right: 10px;
                white-space: nowrap;
            }
        }
        .custom-desc {
            font-size: 12px;
            color: #909399;
        }
    }
}
</style>